import { CHECK_AB_CONFIG } from 'reactApp/appHelpers/featuresHelpers/features/checkAB';

export const getIsUserEnabled = ({
    isBizUser,
    isCorpUser,
    isSocialUser,
    isVKIDSocialUser,
}: {
    isBizUser: boolean;
    isCorpUser: boolean;
    isSocialUser: boolean;
    isVKIDSocialUser: boolean;
}): boolean => {
    const { corpEnabled, socialEnabled, bizEnabled } = CHECK_AB_CONFIG;

    const isRegularUser = !isBizUser && !isCorpUser && !isSocialUser && !isVKIDSocialUser;
    const isBizUserEnabled = isBizUser && bizEnabled;
    const isCorpUserEnabled = isCorpUser && corpEnabled;
    const isSocialUserEnabled = (isSocialUser || isVKIDSocialUser) && socialEnabled;

    return isRegularUser || isBizUserEnabled || isCorpUserEnabled || isSocialUserEnabled;
};

export const getIsAllowedDevice = (isMobile: boolean): boolean => {
    const { deviceType } = CHECK_AB_CONFIG;

    return deviceType === 'all' ? true : deviceType === 'mobile' ? isMobile : !isMobile;
};
